import { Card } from 'antd';
import moment from 'moment-timezone';
import React from 'react';

import { momentFormat } from '../../utils/common';

export const FinishPopupContent = ({ t, point }) => {
  return (
    <Card bordered={false} bodyStyle={{ padding: 0, textAlign: 'left' }}>
      <strong>{point.formattedAddress || t('endLocation')}</strong>
      {point.journeyEndTs ? (
        <div>
          <strong>{t('endTime')}:</strong>{' '}
          {momentFormat(point.journeyEndTs, 'YYYY-MM-DD hh:mm a zz')}
        </div>
      ) : null}
      {point.journeyEndTs && point.journeyStartTs ? (
        <div>
          <strong>{t('duration')}:</strong>{' '}
          {Math.round(
            moment.duration(moment(point.journeyEndTs).diff(point.journeyStartTs)).asMinutes(),
          )}{' '}
          min.
        </div>
      ) : null}
      {point.journeyDistance ? (
        <div>
          <strong>{t('Distance')}:</strong> {point.journeyDistance}
        </div>
      ) : null}
      {(point.journeyIdleTime || point.journeyIdleTime === 0) && (
        <div>
          <strong>{t('idleTime')}:</strong> {point.journeyIdleTime}
        </div>
      )}
    </Card>
  );
};
